import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { call, put, takeEvery } from 'redux-saga/effects';
import { initialize, requestFailure, requestSuccess } from './actionCreators';
import { request } from '../../xhr';
function getFakeData({ params: { username  }  }) {
    if (process.env.NODE_ENV !== 'production') {
        const { users , deviationsByType , Fake , deviations  } = require('@wix/da-sample-data'); // eslint-disable-line global-require
        const { Chance  } = require('chance'); // eslint-disable-line global-require
        const chance = new Chance();
        // TODO: Change to PapiDaSharedUserInfo when able
        const data = {
            user: _object_spread_props(_object_spread({}, users.find((u)=>u.username === username) || chance.pickone(users)), {
                username,
                profile: {
                    tagline: 'Digital Artist',
                    profilePic: chance.pickone(deviationsByType.image)
                },
                stats: {
                    watchers: chance.natural({
                        max: 40000
                    }),
                    friends: chance.natural({
                        max: 1000
                    })
                }
            }),
            deviationsCount: chance.natural({
                max: 999
            }),
            description: Fake.makeEditorText(),
            featuredDeviations: chance.pickset(deviations, 10),
            mutualWatchedUsers: chance.pickset(users, 2),
            mutualWatchedUsersCount: 5
        };
        return data;
    }
    return false;
}
function* handleInitialize(action) {
    const { username  } = action.payload;
    const result = yield call(request, {
        method: 'get',
        url: 'user/info',
        params: {
            username,
            expand: 'user.stats,user.profile,user.watch'
        }
    }, getFakeData);
    if (result) {
        yield put(requestSuccess(username, result));
    } else {
        yield put(requestFailure(username));
    }
}
export default function* UserAvatarPopoverRootSaga() {
    yield takeEvery(initialize, handleInitialize);
}
